var _excluded = ["hyphens", "truncated", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from 'react';
import { Box } from "../box/Box";
import styled from '@emotion/styled';
import { NeoSystem, NeoSystemProps } from "../../system";
import { SIZES } from "./constants";
var truncatedStyles = {
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  overflow: 'hidden'
};

var baseStyle = function baseStyle(props) {
  var _props$theme$lineHeig;

  return _objectSpread({
    hyphens: props.hyphens ? 'auto' : '',
    lineHeight: (_props$theme$lineHeig = props.theme.lineHeights) === null || _props$theme$lineHeig === void 0 ? void 0 : _props$theme$lineHeig[props.lineHeight || props.fontSize]
  }, props.truncated ? truncatedStyles : {});
};

var StyledBox = styled(Box)(baseStyle, NeoSystem.TYPOGRAPHY);
var Text = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$hyphens = _ref.hyphens,
      hyphens = _ref$hyphens === void 0 ? true : _ref$hyphens,
      _ref$truncated = _ref.truncated,
      truncated = _ref$truncated === void 0 ? false : _ref$truncated,
      size = _ref.size,
      others = _objectWithoutProperties(_ref, _excluded);

  var sizeStyles = size ? SIZES[size] : {};
  return /*#__PURE__*/React.createElement(StyledBox, _extends({
    as: "p",
    hyphens: hyphens,
    truncated: truncated,
    ref: ref
  }, sizeStyles, others));
});
Text.Transform = Object.freeze({
  Uppercase: 'uppercase',
  Lowercase: 'lowercase'
});
Text.displayName = 'Text';
export { Text };
export default Text;